import { render } from "./LiveDetail.vue?vue&type=template&id=1927c9c8&scoped=true"
import script from "./LiveDetail.vue?vue&type=script&lang=ts"
export * from "./LiveDetail.vue?vue&type=script&lang=ts"

import "./LiveDetail.vue?vue&type=style&index=0&id=1927c9c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1927c9c8"

export default script